// extracted by mini-css-extract-plugin
export default {"container":"t_-z","creativeContainer":"u_-z","copy":"v_-z","cta":"w_-z","disabled":"x_-z","flipped":"y_-z","productCard":"z_-z"};